import React, { useEffect } from 'react';
import ContactForm from '../components/ContactForm';
import ProjectsSection from '../components/ProjectsSection';
import TeamSection from '../components/TeamSection';
import HeroCarousel from '../components/HeroCarousel';
import '../styles/home.css';

const ServiceIcon = ({ type }) => {
  const icons = {
    grid: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1F3864" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="2" width="8" height="8" rx="1.5" /><rect x="14" y="2" width="8" height="8" rx="1.5" />
        <rect x="2" y="14" width="8" height="8" rx="1.5" /><rect x="14" y="14" width="8" height="8" rx="1.5" />
        <path d="M10 6h4M6 10v4M18 10v4M10 18h4" />
      </svg>
    ),
    shield: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#C00000" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" /><path d="M9 12l2 2 4-4" />
      </svg>
    ),
    code: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1F3864" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="16 18 22 12 16 6" /><polyline points="8 6 2 12 8 18" />
      </svg>
    ),
    wifi: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#1F3864" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M5 12.55a11 11 0 0 1 14 0" /><path d="M1.42 9a16 16 0 0 1 21.16 0" />
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" /><line x1="12" y1="20" x2="12.01" y2="20" />
      </svg>
    ),
    chart: (
      <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#C00000" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 3v18h18" /><path d="M7 14l4-4 4 4 5-6" />
      </svg>
    )
  };
  return icons[type] || null;
};

const HomePage = () => {
  useEffect(() => {
    if (window.location.hash) {
      const id = window.location.hash.slice(1);
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
  }, []);

  const services = [
    {
      id: 1,
      title: 'Infrastructure & Réseaux',
      description: 'Conception, déploiement et supervision de réseaux d\'entreprise fiables, performants et évolutifs.',
      icon: 'grid',
      iconBg: 'blue'
    },
    {
      id: 2,
      title: 'Cybersécurité',
      description: 'Audit, durcissement, protection et réponse à incident pour sécuriser vos systèmes et vos données.',
      icon: 'shield',
      iconBg: 'red'
    },
    {
      id: 3,
      title: 'Développement logiciel',
      description: 'Applications web et métiers sur-mesure, robustes, évolutives et pensées pour vos usages.',
      icon: 'code',
      iconBg: 'blue'
    },
    {
      id: 4,
      title: 'Télécoms & Connectivité',
      description: 'Connectivité, VoIP et liaisons inter-sites pour relier et fluidifier vos opérations.',
      icon: 'wifi',
      iconBg: 'blue'
    },
    {
      id: 5,
      title: 'Conseil & Transformation',
      description: 'Stratégie, cadrage et accompagnement de bout en bout de vos projets de transformation digitale.',
      icon: 'chart',
      iconBg: 'red'
    }
  ];

  const stats = [
    { value: '120', suffix: '+', label: 'Projets livrés' },
    { value: '60', suffix: '+', label: 'Clients & institutions' },
    { value: '8', suffix: '', label: 'Années d\'expertise' },
    { value: '24/7', suffix: '', label: 'Supervision & support' }
  ];

  return (
    <main className="home-page">
      {/* HERO */}
      <section id="top" className="hero">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-badge">
              <span className="pulse"></span>
              <span>Ingénierie IT · Réseaux · Cybersécurité — Yaoundé</span>
            </div>
            <h1 className="hero-title">
              L'ingénierie qui<br />
              sécurise votre<br />
              <span className="hero-gradient">transformation numérique</span>
            </h1>
            <p className="hero-description">
              Nexus Africa Solutions conçoit, déploie et protège les infrastructures, réseaux et logiciels des entreprises et institutions camerounaises. Une vitrine d'excellence, rapide et sécurisée.
            </p>
            <div className="hero-buttons">
              <a href="#contact" className="btn btn-primary">
                Démarrer un projet
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </a>
              <a href="#services" className="btn btn-secondary">
                Nos expertises
              </a>
            </div>
            <div className="hero-trust">
              <div className="hero-trust-item">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#1F8A5B" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                <span>HTTPS &amp; sécurité de bout en bout</span>
              </div>
              <div className="hero-trust-item">
                <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#1F8A5B" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
                <span>Supervision 24/7</span>
              </div>
            </div>
          </div>

          <HeroCarousel />
        </div>

        <div className="trust-strip">
          <span className="trust-strip-label">Ils nous font confiance</span>
          <div className="trust-logos">
            <img src="/assets/clients/minpostel.png" alt="MINPOSTEL" className="trust-logo" />
            <img src="/assets/clients/afriland.png" alt="Afriland First Bank" className="trust-logo" />
            <img src="/assets/clients/camtel.png" alt="Camtel" className="trust-logo trust-logo-camtel" />
            <img src="/assets/clients/eneo.png" alt="Eneo" className="trust-logo" />
            <img src="/assets/clients/orabank.png" alt="Orabank" className="trust-logo" />
          </div>
        </div>
      </section>

      {/* SERVICES */}
      <section id="services" className="services">
        <div className="section-header">
          <span className="section-label">Nos expertises</span>
          <h2>Une ingénierie complète, du réseau à la cybersécurité</h2>
          <p>Cinq domaines de compétence pour bâtir, connecter et protéger votre système d'information.</p>
        </div>

        <div className="services-grid">
          {services.map((service) => (
            <div key={service.id} className="service-card">
              <div className={`service-icon service-icon-${service.iconBg}`}>
                <ServiceIcon type={service.icon} />
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <a href="#contact" className="service-link">
                En savoir plus
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </a>
            </div>
          ))}
          <div className="service-card special">
            <div>
              <h3>Un besoin spécifique ?</h3>
              <p>Parlons de votre contexte. Nos ingénieurs construisent la réponse adaptée à vos enjeux.</p>
            </div>
            <a href="#contact" className="btn btn-white">
              Nous contacter
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </div>
        </div>
      </section>

      {/* STATS */}
      <section className="stats">
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-value">
                {stat.value}
                {stat.suffix && <span className="stat-plus">{stat.suffix}</span>}
              </div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </section>

      <ProjectsSection />

      {/* ABOUT */}
      <section id="about" className="about">
        <div className="about-container">
          <div className="about-content">
            <span className="section-label">À propos</span>
            <h2>Une société camerounaise d'ingénierie &amp; de cybersécurité</h2>
            <p>
              Basée à Yaoundé, Nexus Africa Solutions accompagne entreprises, institutions et collectivités dans leurs projets d'infrastructure, de sécurité et de transformation numérique — et développe ses propres solutions au service du continent.
            </p>
            <div className="about-features">
              <div className="feature">
                <div className="feature-icon feature-icon-blue">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#1F3864" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 6L9 17l-5-5" />
                  </svg>
                </div>
                <div>
                  <h4>Expertise locale, standards internationaux</h4>
                  <p>Des ingénieurs ancrés au Cameroun, des pratiques alignées sur l'état de l'art.</p>
                </div>
              </div>
              <div className="feature">
                <div className="feature-icon feature-icon-red">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#C00000" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>
                <div>
                  <h4>La sécurité par défaut</h4>
                  <p>La cybersécurité irrigue chacune de nos missions, de la conception à l'exploitation.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="testimonial">
            <svg className="quote-icon" width="40" height="40" viewBox="0 0 24 24" fill="#C00000">
              <path d="M7 7h4v4c0 3-2 5-5 5V14c1 0 2-1 2-2H7V7zm9 0h4v4c0 3-2 5-5 5V14c1 0 2-1 2-2h-1V7z" />
            </svg>
            <blockquote>
              « Nexus a sécurisé et fiabilisé tout notre système d'information. Une équipe rigoureuse, disponible, qui comprend les enjeux d'une institution. »
            </blockquote>
            <div className="testimonial-author">
              <div className="author-avatar">DM</div>
              <div>
                <div className="author-name">Direction des Systèmes d'Information</div>
                <div className="author-title">Institution financière · Yaoundé</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TeamSection />

      {/* CONTACT */}
      <section id="contact" className="contact">
        <div className="contact-container">
          <div className="contact-info">
            <h2>Discutons de votre projet</h2>
            <p>
              Un audit, une infrastructure, une application, un besoin de sécurité ? Décrivez votre projet — nous revenons vers vous rapidement.
            </p>
            <div className="contact-details">
              <div className="detail">
                <div className="detail-icon">
                  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="2" y="4" width="20" height="16" rx="2" />
                    <path d="M22 6l-10 7L2 6" />
                  </svg>
                </div>
                <div>
                  <div className="detail-label">E-mail</div>
                  <div className="detail-value">contact@nexusafricasolutions.com</div>
                </div>
              </div>
              <div className="detail">
                <div className="detail-icon">
                  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92z" />
                  </svg>
                </div>
                <div>
                  <div className="detail-label">Téléphone</div>
                  <div className="detail-value">+237 6 56 32 45 38</div>
                </div>
              </div>
              <div className="detail">
                <div className="detail-icon">
                  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
                    <circle cx="12" cy="10" r="3" />
                  </svg>
                </div>
                <div>
                  <div className="detail-label">Adresse</div>
                  <div className="detail-value">Yaoundé, Cameroun</div>
                </div>
              </div>
            </div>
          </div>

          <ContactForm />
        </div>
      </section>
    </main>
  );
};

export default HomePage;
